import { render, staticRenderFns } from "./TransactionStats.vue?vue&type=template&id=2810db36&"
import script from "./TransactionStats.vue?vue&type=script&lang=js&"
export * from "./TransactionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports